import { upperCase } from 'es-toolkit';
import React from 'react';

import { INDETERMINATE, IndeterminateValue, PropertySelectField } from '@paragon/client-tools';
import { BuildingCode, DesignStandard } from '@paragon/contract-library';

import { getDeterminateValueOrNull } from '../../../../dialogs/project-wide-settings/LoadedProjectWideSettingsDialog';
import { LoadSettingsWithDesignStandard } from './LoadSettingsControls';
import { DesignCode, ValidDesignCodes } from './validDesignCodes';

export type { DesignCode } from './validDesignCodes';

// IBC/IRC 2009 reference ASCE 7-05, which we don't support, so we don't want to provide those options.
const ValidDesignCodeOptions = ValidDesignCodes.filter(
  ([buildingCode]) => buildingCode !== 'Ibc2009' && buildingCode !== 'Irc2009',
);

export function formatDesignCode(designCode: DesignCode) {
  return `${formatBuildingCodeOrDesignStandard(designCode[0])} ${formatBuildingCodeOrDesignStandard(designCode[1])}`;
}

export function formatBuildingCodeOrDesignStandard(
  buildingCodeOrDesignStandard: BuildingCode | DesignStandard,
): string {
  return upperCase(buildingCodeOrDesignStandard);
}

export function DesignCodeField({
  isViewOnly,
  loadSettingsWithDesignStandardsArray,
  applyDesignCodeChange,
}: {
  readonly isViewOnly: boolean;
  readonly loadSettingsWithDesignStandardsArray: readonly LoadSettingsWithDesignStandard[];
  readonly applyDesignCodeChange: (designCode: DesignCode) => void;
}) {
  const designCodeValues: DesignCode[] = loadSettingsWithDesignStandardsArray.map((loadSettingsWithDesignStandard) => [
    loadSettingsWithDesignStandard.loadSettings.buildingCode,
    loadSettingsWithDesignStandard.designStandard,
  ]);
  const determinateDesignCode = getDeterminateValueOrNull(designCodeValues);
  const value: DesignCode | IndeterminateValue = determinateDesignCode ?? INDETERMINATE;

  return (
    <PropertySelectField<DesignCode>
      property="Design Code"
      value={value}
      options={ValidDesignCodeOptions}
      getName={formatDesignCode}
      disabled={isViewOnly}
      submit={applyDesignCodeChange}
    />
  );
}
